/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './repost.defs'
export { main as default } from './repost.defs'
